module.exports = __webpack_public_path__ + "img/bg-screen.c6a276ae.png";